var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
var VisitCaseManageService = /** @class */ (function () {
    function VisitCaseManageService() {
    }
    /**
     * 外访个人案件池查询列表
     */
    VisitCaseManageService.prototype.visitPersonalCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitPersonalCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访待分配案件池查询列表
     */
    VisitCaseManageService.prototype.visitWaitDistribution = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitWaitDistribution,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访停催案件池查询列表
     */
    VisitCaseManageService.prototype.visitPauseCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitPauseCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访回收案件池查询列表
     */
    VisitCaseManageService.prototype.visitRecoverCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitRecoverCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访归c案件池查询列表
     */
    VisitCaseManageService.prototype.visitReturnCCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitReturnCCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访结清案件池查询列表
     */
    VisitCaseManageService.prototype.visitSettleCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitSettleCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访团队案件池查询列表
     */
    VisitCaseManageService.prototype.visitTeamCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitTeamCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 外访个人案件池申请流转
     */
    VisitCaseManageService.prototype.visitPersonalTurn = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitPersonalTurn,
            data: data,
        });
    };
    /**
     * 外访停催申请
     */
    VisitCaseManageService.prototype.visitPauseCase = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitPauseCase,
            data: data,
        });
    };
    /**
     * 外访留案申请
     */
    VisitCaseManageService.prototype.visitCaseStay = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitCaseStay,
            data: data,
        });
    };
    /**
     * 外访案件手动分案预览
     */
    VisitCaseManageService.prototype.reviewDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.reviewDistributeCase,
            data: data,
        });
    };
    /**
     * 外访案件手动分案确认
     * @param data
     */
    VisitCaseManageService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.confirmDistributeCase,
            data: data,
        });
    };
    /**
     * 外访案件手动分案确认
     * @param data
     */
    VisitCaseManageService.prototype.returnCase = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.returnCase,
            data: data,
        });
    };
    /**
     * 回收案件移入待分配
     * @param caseIds
     */
    VisitCaseManageService.prototype.moveToWaitDistribution = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.moveToWaitDistribution,
            data: data,
        });
    };
    /**
     * 外访个人案件池查询列表逾期总金额
     */
    VisitCaseManageService.prototype.visitPersonalCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitPersonalCasePoolAmount,
            data: data
        });
    };
    /**
     * 外访团队案件池查询列表逾期总金额
     */
    VisitCaseManageService.prototype.visitTeamCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.visitCaseManageController.visitTeamCasePoolAmount,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], VisitCaseManageService.prototype, "netService", void 0);
    return VisitCaseManageService;
}());
export { VisitCaseManageService };
